module.exports = __webpack_public_path__ + "static/media/git-flow-condensed.253c8fa8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/git-more-done/assets/git-flow-condensed.jpeg
// module id = 397
// module chunks = 0